var BROWSER_EVENTS = {
  VISIBILITY_CHANGE: 'VISIBILITY_CHANGE'
};
var PLAYER_EVENTS = {
  SEEK: 'SEEK'
};

var LOADER_EVENTS = {
  LADER_START: 'LOADER_START',
  LOADER_DATALOADED: 'LOADER_DATALOADED',
  LOADER_COMPLETE: 'LOADER_COMPLETE',
  LOADER_ERROR: 'LOADER_ERROR'
};

var DEMUX_EVENTS = {
  DEMUX_START: 'DEMUX_START',
  DEMUX_COMPLETE: 'DEMUX_COMPLETE',
  DEMUX_ERROR: 'DEMUX_ERROR',
  METADATA_PARSED: 'METADATA_PARSED',
  SEI_PARSED: 'SEI_PARSED',
  VIDEO_METADATA_CHANGE: 'VIDEO_METADATA_CHANGE',
  AUDIO_METADATA_CHANGE: 'AUDIO_METADATA_CHANGE',
  MEDIA_INFO: 'MEDIA_INFO'
};

var REMUX_EVENTS = {
  REMUX_METADATA: 'REMUX_METADATA',
  REMUX_MEDIA: 'REMUX_MEDIA',
  MEDIA_SEGMENT: 'MEDIA_SEGMENT',
  REMUX_ERROR: 'REMUX_ERROR',
  INIT_SEGMENT: 'INIT_SEGMENT',
  DETECT_CHANGE_STREAM: 'DETECT_CHANGE_STREAM',
  DETECT_CHANGE_STREAM_DISCONTINUE: 'DETECT_CHANGE_STREAM_DISCONTINUE',
  RANDOM_ACCESS_POINT: 'RANDOM_ACCESS_POINT'
};

var MSE_EVENTS = {
  SOURCE_UPDATE_END: 'SOURCE_UPDATE_END'

  // hls专有events
};var HLS_EVENTS = {
  RETRY_TIME_EXCEEDED: 'RETRY_TIME_EXCEEDED'
};

var CRYTO_EVENTS = {
  START_DECRYPT: 'START_DECRYPT',
  DECRYPTED: 'DECRYPTED'
};
var ALLEVENTS = Object.assign({}, LOADER_EVENTS, DEMUX_EVENTS, REMUX_EVENTS, MSE_EVENTS, HLS_EVENTS, PLAYER_EVENTS, BROWSER_EVENTS);

var FlvAllowedEvents = [];
var HlsAllowedEvents = [];

for (var key in ALLEVENTS) {
  if (ALLEVENTS.hasOwnProperty(key)) {
    FlvAllowedEvents.push(ALLEVENTS[key]);
  }
}

for (var _key in ALLEVENTS) {
  if (ALLEVENTS.hasOwnProperty(_key)) {
    HlsAllowedEvents.push(ALLEVENTS[_key]);
  }
}

export default {
  ALLEVENTS: ALLEVENTS,
  HLS_EVENTS: HLS_EVENTS,
  REMUX_EVENTS: REMUX_EVENTS,
  DEMUX_EVENTS: DEMUX_EVENTS,
  MSE_EVENTS: MSE_EVENTS,
  LOADER_EVENTS: LOADER_EVENTS,
  FlvAllowedEvents: FlvAllowedEvents,
  HlsAllowedEvents: HlsAllowedEvents,
  CRYTO_EVENTS: CRYTO_EVENTS,
  PLAYER_EVENTS: PLAYER_EVENTS,
  BROWSER_EVENTS: BROWSER_EVENTS
};